export const downloadBlob = (blob: Blob, fileName: string) => {
  const url = URL.createObjectURL(blob);

  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = fileName;
  anchor.click();
};

// Downloads under the server's Content-Disposition filename when available
// (useCustomInstance wraps such responses in a File), otherwise the fallback.
export const downloadFile = (blob: Blob, fallbackFileName: string) => {
  downloadBlob(
    blob,
    blob instanceof File && blob.name ? blob.name : fallbackFileName
  );
};

export default {
  downloadBlob,
  downloadFile,
};
